import { Link, useSearchParams } from 'react-router-dom'
import { ResetPasswordForm } from '@/components/auth/ResetPasswordForm'
import { AuthLogo } from '@/components/auth/AuthLogo'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'
import { Alert, Box, Card, CardContent, Typography } from '@mui/material'
import '@/styles/auth.css'

/**
 * Страница установки нового пароля по ссылке из письма
 * (`/reset-password?token=…&email=…`).
 */
export function ResetPasswordPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const email = searchParams.get('email') ?? ''
  const linkValid = token !== '' && email !== ''

  return (
    <Box className="auth-page">
      <Box className="auth-language-switcher">
        <LanguageSwitcher />
      </Box>
      <Box className="auth-container">
        <Card className="auth-card">
          <CardContent>
            <AuthLogo />

            <Typography variant="h1" component="h1" sx={{ textAlign: 'center', mb: 1 }}>
              {t('auth.resetPasswordTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
              {t('auth.resetPasswordSubtitle')}
            </Typography>

            {linkValid ? (
              <ResetPasswordForm token={token} email={email} />
            ) : (
              <Alert severity="error" sx={{ borderRadius: 2 }}>
                {t('auth.resetPasswordInvalidLink')}{' '}
                <Link to={ROUTES.FORGOT_PASSWORD} className="auth-link">
                  {t('auth.forgotPassword')}
                </Link>
              </Alert>
            )}

            <Box className="auth-footer">
              <Typography variant="body2">
                <Link to={ROUTES.LOGIN} className="auth-link">
                  {t('auth.backToLogin')}
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
